import axios from "@/api";
import authHeader from "@/services/auth-header";

const BASE =
    process.env.VUE_APP_API_URL;


export function getFileContent(buttonName, buttonType) {
    return axios.post(
        process.env.VUE_APP_API_URL + "file/fileList",
        {
            name: buttonName,
            type: buttonType,
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    )
}

export function getAllFilesInFolder(oldDir, folder) {

    return axios.post(
        BASE + "file/getAllFilesInFolder",
        {
            dir: oldDir,
            folder
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    );
}


export function moveFile(oldDir, newDir, subDir, file) {

    return axios.post(
        BASE + "file/fileMove",
        {
            oldDir,
            newDir,
            subDir,
            file
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    );
}


export function copyFile(oldDir, newDir, subDir, file) {

    return axios.post(
        BASE + "file/fileCopy",
        {
            oldDir,
            newDir,
            subDir,
            file
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    );
}

export function postFileRecycle(files, oldDir, isForceDelete) {
    return axios.post(
        process.env.VUE_APP_API_URL + "file/fileRecycle",
        {
            files,
            oldDir,
            isForceDelete
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    );
}


export function postFileDelete(files) {
    return axios.post(
        process.env.VUE_APP_API_URL + "file/fileDelete",
        {
            files
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    );
}

export function postFolderCreate(newDirName) {
    return axios.post(
        process.env.VUE_APP_API_URL + "file/folderCreate",
        {
            newDirName
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
    );
}

export function postFileUpload(formData) {
    return axios.post("/file/fileUpload",
        formData,
        {
            headers: authHeader(),
            withCredentials: true
        });
}